









import { Component, Prop, Vue } from "vue-property-decorator";
import store from "./store";

@Component({})
export default class App extends Vue {
  $q;
  constructor() {
    super();
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
